export { default } from './Intro'



// WEBPACK FOOTER //
// ./src/components/Intro/index.ts